var paragraph_default = {
  "fontElementMap": "IMAjz",
  "elementSpacing": "c9qfw",
  "text": "_8NOrx c9qfw",
  "child": "_0XiBD"
};
export {
  paragraph_default as default
};
//# sourceMappingURL=paragraph-scss.js.map
